import Rest from 'services/data/rest';
import _ from 'lodash';

export default class Address extends Rest {
  static path = 'address';

  static getGoogleMapsPlace(addressObject) {
    const { address, city, state, zip } = addressObject;

    return _.replace(`${address} ${city} ${state} ${zip}`, / /g, '+');
  }
}
